import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { Text } from "@cars24/turbo-web/lib/text";
import StateChallanInfoCard from "../state-challan-info-card";

const StateEChallanComplaint = ({ eChallanComplaint = {} }) => {

    const { tokens } = useTokens();

    const { title = "", transactionSection = {}, statusSection = {} } = eChallanComplaint || {};

    return (
        <div styleName={"styles.wrapper"}>
            <Text size="400" fontWeight="semibold" color={tokens.text_Default_text_primary}>{title}</Text>
            <div styleName={"styles.boxWrapper"}>
                {transactionSection?.sectionData?.length > 0 && <StateChallanInfoCard title={transactionSection?.title} list={transactionSection?.sectionData} />}
                {statusSection?.sectionData?.length > 0 && <StateChallanInfoCard title={statusSection?.title} list={statusSection?.sectionData} />}
            </div>
        </div>
    );
};

StateEChallanComplaint.propTypes = {
    eChallanComplaint: PropTypes.object
};

export default StateEChallanComplaint;
